import {
  Divider,
  Headline,
  HeadlineProps,
  styled,
} from '@zeiss/beyond-online-react';

interface PageHeaderProps extends HeadlineProps {
  /**
   * Whether to display the divider or not
   */
  divider?: boolean;
}

const StyledHeadline = styled(Headline)`
  margin-bottom: var(--spacing-responsive-m);
`;

export const PageHeader = ({
  divider,
  headline,
  ...props
}: PageHeaderProps) => {
  return (
    <>
      <StyledHeadline data-testid="PageHeader" headline={headline} {...props} />
      {divider && <Divider size="m" />}
    </>
  );
};
